module.exports = __webpack_public_path__ + "static/media/indo-mim.5d3e3a4d.svg";